import React from 'react';
import './ErrorMessage.css'

class ErrorMessage extends React.Component {
  render() {
    const showErrorMessage = this.props.showErrorMessage
    const errorMessage = this.props.errorMessage;
    if (showErrorMessage) {
      return (
        <div className="alert alert-danger error_message" role="alert">
          <span role="img" aria-label="sad face">😭</span> {errorMessage} <span role="img" aria-label="sad face">😭</span>
        </div>
      );
    } else {
      return (
        <div className="error_placeholder">
        </div>
      );
    }
  }
}

export default ErrorMessage;



// WEBPACK FOOTER //
// ./src/components/Utils/ErrorMessage.js